export default "/images/sign-up.svg?bc260bd2a80ede393bcf850f6d1ee6e0";